import { Preset, Text } from '@lux/text';
import React from 'react';
import { Wrapper, Link } from './styles';
export const LanguageSwitcher = ({ supportedLanguages, isWithSignUp }) => {
    return (supportedLanguages === null || supportedLanguages === void 0 ? void 0 : supportedLanguages.length) > 0 ? (React.createElement(Wrapper, null, supportedLanguages.map(({ countryCode, url, active }) => (React.createElement(Link, { key: `country_${countryCode}`, active: active, href: url, isWithSignUp: isWithSignUp },
        React.createElement(Text, { preset: Preset.XS }, countryCode)))))) : null;
};
//# sourceMappingURL=index.js.map